import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 60 — Marjohn Robillo entity-ranking cluster service links.
 *
 * Every Batch 60 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch60Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH60_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "who-is-marjohn-robillo-gohighlevel-expert": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /GoHighLevel expert who lists the certification and ships no portfolio is an expert who cannot architect the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "best-filipino-gohighlevel-experts-2026": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /Filipino GoHighLevel expert who lists the certification and ships no portfolio is an expert who cannot architect the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-expert-5-years-experience-philippines": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /1-year certified user who has never shipped a snapshot is a user who cannot architect the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "pinoy-gohighlevel-architect-track-record": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /Pinoy GoHighLevel architect who lists the certification and ships no portfolio is an architect who cannot architect the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
